module.exports = __webpack_public_path__ + "img/iso-9001.8d4f0b3.webp";